import { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import Modal from "@shared/v2/Modal";
import TextComboInput from "@shared/v2/TextComboInput";
import Button from "@shared/v2/Button";
import { useContactPerson } from "../../reducers/contactsReducer/selectors";
import { setPersonValue } from "../../reducers/contactsReducer";

const EditSubdomainModal = ({ show, onClose }) => {
  const person = useContactPerson();
  const dispatch = useDispatch();
  const { domain } = person;

  const [subdomainValue, setSubdomainValue] = useState("");

  useEffect(() => {
    if (person?.loginUserAttributes?.subdomain) {
      setSubdomainValue(person?.loginUserAttributes?.subdomain);
    }
  }, [person?.loginUserAttributes?.subdomain]);

  const onCloseHandlr = () => {
    setSubdomainValue(person?.loginUserAttributes?.subdomain);
    onClose();
  };

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      contentClassName="tw-w-[616px] tw-h-[332px] tw-flex tw-flex-col tw-gap-[32px]"
      show={show}
      onHide={onCloseHandlr}
    >
      <Modal.Header
        className="tw-relative tw-text-gray-50"
        title="Edit Subdomain"
        description="Changes may take up to 30 minutes to reflect on your Brivity website"
        closeButton
      />
      <Modal.Body className="tw-relative tw-flex tw-items-center tw-gap-4px tw-overflow-hidden">
        <TextComboInput
          label="Subdomain"
          value={subdomainValue}
          containerClassName="tw-flex-1 tw-flex tw-h-[84px]"
          onChange={(e) => setSubdomainValue(e.target.value)}
          error={subdomainValue.trim().length === 0 ? "This field is required" : null}
          isRequired
        />
        <span className="tw-text-gray-50 tw-leading-[36px]">.{domain}</span>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between ">
        <Button schema="tertiary" size="medium" onClick={onCloseHandlr}>
          Cancel
        </Button>
        <Button
          size="medium"
          onClick={() => {
            dispatch(setPersonValue({ key: "loginUserAttributes.subdomain", value: subdomainValue }));
            onClose();
          }}
          disabled={subdomainValue.trim().length === 0}
          schema="primary"
        >
          SAVE
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditSubdomainModal;

EditSubdomainModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
EditSubdomainModal.defaultProps = {
  show: false,
};
